import type { Counters } from "../../../api/types";
import { Counter } from "../../../ui";
import type { DisplayState } from "../../../ui/state";
import type { ReplayCounts } from "../model/replay";

export interface CounterItem {
  label: string;
  value: number;
  tone?: DisplayState;
}

/** The counters of the live view: validated, waiting for the SME, proposed, sent back, notes waiting. */
export function liveCounterItems(counters: Counters): CounterItem[] {
  return [
    { label: "validated", value: counters.validated, tone: "validated" },
    { label: "waiting for the SME", value: counters.waiting, tone: "waiting" },
    { label: "proposed", value: counters.proposed, tone: "proposed" },
    { label: "sent back", value: counters.sent_back, tone: "sent_back" },
    { label: counters.notes_waiting === 1 ? "note waiting for an answer" : "notes waiting for an answer", value: counters.notes_waiting },
    { label: "loaded", value: counters.loaded, tone: "loaded" },
  ];
}

/** The counters at a point of the replay. Proposals and notes are not part of the record, so they are not counted. */
export function replayCounterItems(counts: ReplayCounts): CounterItem[] {
  return [
    { label: "validated", value: counts.validated, tone: "validated" },
    { label: "waiting for the SME", value: counts.waiting, tone: "waiting" },
    { label: "sent back", value: counts.sent_back, tone: "sent_back" },
    { label: "rejected", value: counts.rejected, tone: "rejected" },
    { label: "loaded", value: counts.loaded, tone: "loaded" },
  ];
}

export function CounterRow({ items, label = "Counters" }: { items: CounterItem[]; label?: string }) {
  return (
    <div className="nv-counters" role="group" aria-label={label}>
      {items.map((item) => (
        <Counter key={item.label} label={item.label} value={item.value} tone={item.tone} />
      ))}
    </div>
  );
}
